import Header from "./common/Header.js";
import Footer from "./common/Footer.js";
import PaymentForm from "./PaymentForm.js";
import Back from "./images/Back.svg";
import Checkmark from "./images/Checkmark.svg";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import api from "./api/Api.js";

export default function SignupWizardPayment(props) {
  if (props.state.wizardStep !== "payment") {
    return null;
  }
  return (
    <div className="App" style={{ backgroundColor: props.state.wizardStep === "confirmation" ? "#4f196f" : "#f3f3f3" }}>
      <Header />
      <div>
        <PaymentStepHeader currentState={props.state} setWizardStep={props.setWizardStep} />
        <MembershipIncludes currentState={props.state} />
        <PaymentRate
          handleChange={props.handleChange}
          currentState={props.state}
          toggleInviteCode={props.toggleInviteCode2}
          applyInviteCode={props.applyInviteCode}
          removeInviteCode={props.removeInviteCode}
          getBillingDate={props.getBillingDate}
        />
        <PaymentInfo currentState={props.state} setWizardStep={props.setWizardStep} />
      </div>
      <Footer />
    </div>
  );
}

const PaymentStepHeader = (props) => {
  return (
    <div className="section wide img light gray apply">
      <div style={{ display: "table", columns: "2", width: "100%", maxWidth: "978px" }}>
        <div style={{ display: "table-row" }}>
          <div style={{ display: "table-cell", width: "30px", paddingRight: "10px", paddingTop: "20px" }}>
            <img
              style={{ display: props.currentState.isValidInviteCode ? "none" : "block" }}
              src={Back}
              alt=""
              className="backButton"
              onClick={(ev) => {
                props.setWizardStep("signup");
              }}
            />
          </div>
          <div style={{ display: "table-cell", verticalAlign: "middle", textAlign: "center" }}>
            <h1 style={{ display: props.currentState.isValidInviteCode ? "none" : "block" }} className="paymentHeader">
              You qualify for a free 14-day trial!
              <br />
              <div className="paymentSubheader">
                A Duos team member will give you a call shortly to chat about your needs, our services, and payment.
              </div>
            </h1>
            <h1 style={{ display: props.currentState.isValidInviteCode ? "block" : "none" }} className="paymentHeader">
              Your DUOS membership is covered!
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

const MembershipIncludes = (props) => {
  return (
    <div className="section wide img light gray apply">
      <div className="memberpod apply2 top">
        <h2 className="heading-5 lightbg leftheading">Your Membership includes</h2>
        <div className="w-row">
          <div className="column-2 w-col w-col-6">
            <img src={Checkmark} loading="lazy" alt="" className="smallcheck" />
            <p className="caption purple">Welcome Call to personalize your Duos membership program</p>
          </div>
          <div className="column-2 w-col w-col-6">
            <img src={Checkmark} loading="lazy" alt="" className="smallcheck" />
            <p className="caption purple">Access to transportation, nutrition, and community resources</p>
          </div>
        </div>
        <div className="w-row">
          <div className="column-2 w-col w-col-6">
            <img src={Checkmark} loading="lazy" alt="" className="smallcheck" />
            <p className="caption purple">Weekly check-ins with your Duo</p>
          </div>
          <div className="column-2 w-col w-col-6">
            <img src={Checkmark} loading="lazy" alt="" className="smallcheck" />
            <p className="caption purple">14 day risk-free trial. Cancel any time.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const PaymentRate = (props) => {
  return (
    <div className="section wide img light gray apply">
      <div className="memberpod apply2">
        <div className="columns w-row">
          <div className="column-4 vertical w-col w-col-6">
            <p
              className="field-label nopadding"
              style={{ display: props.currentState.isValidInviteCode ? "none" : "block" }}
            >
              Your Plan
            </p>
            <p
              className="field-label bold"
              style={{ display: props.currentState.isValidInviteCode ? "none" : "block" }}
            >
              Free trial ends {props.getBillingDate()}
            </p>
            <p
              className="field-label nopadding"
              style={{ display: props.currentState.isValidInviteCode ? "block" : "none" }}
            >
              Plan Discount Applied
            </p>
          </div>
          <div className="column-2 rightaligned w-col w-col-6">
            <p
              style={{ textDecoration: props.currentState.isValidInviteCode ? "line-through" : "none" }}
              className="field-label"
            >
              $150/month
            </p>
          </div>
        </div>
        <div className="w-row">
          <div className="column-2 w-col w-col-6">
            <p
              style={{ display: props.currentState.isValidInviteCode ? "none" : "block" }}
              className="heading-5 lightbg leftheading large"
            >
              Total Due Today
            </p>
            <p
              style={{ display: props.currentState.isValidInviteCode ? "block" : "none" }}
              className="heading-5 lightbg leftheading large"
            >
              Covered by Your Plan
            </p>
          </div>
          <div className="column-2 rightaligned w-col w-col-6">
            <p
              className="heading-5 lightbg leftheading large"
              style={{ display: props.currentState.isValidInviteCode ? "none" : "block" }}
            >
              $0.00
            </p>
            <p
              className="heading-5 lightbg leftheading large"
              style={{ display: props.currentState.isValidInviteCode ? "block" : "none" }}
            >
              No Cost
            </p>
          </div>
        </div>
        <div className="invitecode closed" style={{ marginBottom: "0px" }}>
          <a
            href="#/"
            role="button"
            onClick={(ev) => {
              ev.preventDefault();
              props.toggleInviteCode();
            }}
            className="infoLink"
          >
            Do you have an invite code?
          </a>
        </div>
        <div style={{ paddingTop: "30px", display: props.currentState.showInviteCode2 === true ? "block" : "none" }}>
          <h2 className="heading-5 lightbg leftheading sub">Enter your invite code</h2>
          <h6 className="subtitle">If you&apos;re applying through a third-party partner, they will provide your code.</h6>
          <input
            value={props.currentState.inviteCode}
            onChange={props.handleChange}
            type="text"
            className="text-field memberinput w-input"
            maxLength="256"
            name="inviteCode2"
            placeholder=""
            id="inviteCode2"
            required=""
            disabled={props.currentState.isValidInviteCode}
            style={{
              borderColor:
                props.currentState.inviteCode2.trim() !== "" && !props.currentState.isValidInviteCode ? "red" : "",
              filter:
                props.currentState.inviteCode2.trim() !== "" && !props.currentState.isValidInviteCode
                  ? "drop-shadow(red 0px 0px 3px)"
                  : "",
              width: "45%",
              display: "block",
              float: "left",
              marginRight: "30px",
              marginBottom: "5px",
            }}
          />
          <button
            style={{
              display: props.currentState.isValidInviteCode ? "none" : "block",
              position: "relative",
              float: "left",
              lineHeight: "30px",
              fontSize: "18px",
              marginTop: "0px",
              width: "20%",
            }}
            className="button-hero sub purple w-button"
            onClick={() => props.applyInviteCode()}
            disabled={props.currentState.isEnrollmentSubmitting}
          >
            <span style={{ display: props.currentState.isEnrollmentSubmitting ? "none" : "block" }}>Apply</span>
            <svg
              style={{
                width: "30px",
                height: "30px",
                display: props.currentState.isEnrollmentSubmitting ? "block" : "none",
              }}
              className="spinner"
              version="1.1"
              id="L9"
              x="0px"
              y="0px"
              viewBox="0 0 100 100"
              enableBackground="new 0 0 0 0"
            >
              <path
                fill="#fff"
                d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
              >
                <animateTransform
                  attributeName="transform"
                  attributeType="XML"
                  type="rotate"
                  dur="1s"
                  from="0 50 50"
                  to="360 50 50"
                  repeatCount="indefinite"
                />
              </path>
            </svg>
          </button>
          <p
            style={{
              display: props.currentState.isValidInviteCode ? "block" : "none",
              float: "left",
              paddingTop: "15px",
            }}
            className="appliedCheck"
          >
            Applied
          </p>
          <div
            style={{
              display:
                props.currentState.inviteCode2.trim() !== "" && !props.currentState.isValidInviteCode ? "block" : "none",
              clear: "left",
            }}
          >
            <p style={{ color: "red" }}>
              Your invite code is invalid. Please try a different code or enter your payment information below.
            </p>
          </div>
          <label
            id="contact-email"
            className="caption invite"
            style={{
              display: props.currentState.isValidInviteCode ? "none" : "block",
              clear: "left",
              marginTop: "30px",
            }}
          >
            Can’t find your invite code? Give us a call 855-212-9242.
          </label>
        </div>
      </div>
    </div>
  );
};

const PaymentInfo = (props) => {
  const stripePromise = api.getPublicStripeKey().then((key) => loadStripe(key));
  return (
    <div>
      <Elements stripe={stripePromise}>
        <PaymentForm currentState={props.currentState} setWizardStep={props.setWizardStep} />
      </Elements>
      <div className="section wide img light gray apply">
        <div
          style={{ display: props.currentState.isValidInviteCode ? "block" : "none", width: "100%", maxWidth: "978px" }}
        >
          <div style={{ marginTop: "25px", marginBottom: "25px" }}>
            <button
              onClick={() => props.setWizardStep("confirmation")}
              className="btn button-hero sub purple w-button"
              style={{ width: "100%" }}
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
